export const addCurrencyFormat = (
  price: string | undefined,
  shopSiteName?: string
) => {
  if (!price) return "";

  // Remove any existing currency symbols ($, €, £, etc.) from the start of the price
  const cleanPrice = price.replace(/^[£$€¥]/, "").trim();

  if (shopSiteName?.toLowerCase().includes("nfr")) {
    return `$${cleanPrice} USD`;
  } else if (shopSiteName?.toLowerCase().includes("otg")) {
    return `$${cleanPrice} CAD`;
  }

  return `$${cleanPrice}`; // fallback
};